<template>
  <!-- 表格keyDown下拉获取列-->
  <ul v-if="show" class="showFocus" :class="isLevel ? 'levelUl' : ''">
    <li
      v-for="(item, index) in selectList"
      :key="index"
      :class="{ selectedItem: item == selectedItem, levelItem: item.pid == 0 }"
      :disabled="item.pid == 0"
      @click="onItemClick(index, item.pid)"
      @mouseenter="mouseEnter(index, item.pid)"
    >
      {{ display ? item[display] : item }}
    </li>
  </ul>
</template>

<script>
export default {
  name: "TdExDropdown",
  props: {
    selectList: {
      type: Array,
      required: false,
    },
    selectedIndex: {
      type: Number,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
    display: String,
    isLevel: Boolean,
    levelName: String,
  },
  computed: {
    selectedItem() {
      // 判断选中的列表的item
      this.$nextTick(() => {
        let item = document.getElementsByClassName("selectedItem").item(0);
        if (item) {
          item.scrollIntoViewIfNeeded();
        }
      });
      let index = this.selectedIndex < 0 ? 0 : this.selectedIndex;
      index =
        index > this.selectList.length - 1 ? this.selectList.length - 1 : index;
      return this.selectList[index];
    },
  },
  methods: {
    onItemClick(index, pid) {
      // 点击传送当前index给父组件TableUnit
      this.$emit("update:selectedIndex", index);
    },
    mouseEnter(index, pid) {
      // 鼠标移入事件 向父组件tableUnit 发送当前选中的下标
      this.$emit("enterSelect", index);
    },
  },
};
</script>


<style lang="stylus" scoped>
.showFocus {
  overflow: auto;
  max-height: 200px;
  margin: 0;
  padding: 0;
  border: 1px solid #ddd;
  background-color: #fff;
  list-style-type: none;
  z-index: 10000;

  li {
    width: 100%;
    min-height: 36px;
    line-height: 36px;
    cursor: pointer;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    box-sizing: border-box;

    .level-ul {
      li {
        background-color: #ffffff;

        &:hover {
          background-color: #C7EDCC;
        }
      }
    }
  }

  .selectedItem {
    background-color: #C7EDCC;
  }

  .levelItem {
    // background-color: #cccccc;
    pointer-events: none;
    text-align: left;
    padding-left: 30px;
    font-weight: bold;
    font-size: 15px;
  }
}

.levelUl {
  li {
    text-align: right;
    padding-right: 30px;
  }
}
</style>
